import { useTranslation } from 'react-i18next';
import { colors, fonts } from 'components/styles/variables';
import { ReactNode } from 'react';

interface Props {
  isSubmitting: boolean;
  children: ReactNode;
}

export default function SubmitButton({ isSubmitting, children }: Props): JSX.Element {
  const { t } = useTranslation();
  return (
    <button type="submit">
      {isSubmitting ? t('submitting') : children}
      <style jsx>{`
        button {
          background-color: ${colors.ALR1};
          margin: 0.4em 0;
          width: 100%;
          padding: 1em 0;
          text-align: center;
          color: white;
          font-size: 18px;
          font-weight: 600;
          border: 0;
          border-radius: 8px;
          font-family: ${fonts.default};
        }
      `}</style>
    </button>
  );
}
